import styles from './AboutProgram.module.css';
import { Link } from 'react-router-dom';

const MasInfo = () => { 
    return (
        <div className={styles.aboutProgramPage}>
            <main>
                <section className={styles.aboutProgram}>
                    <h1>Más información</h1>
                    <p>
                        El acceso a la información detallada está disponible únicamente para usuarios registrados. Le invitamos a <Link to="/registertutor">registrarse</Link> en el sistema para continuar.
                    </p>
                </section>
            </main>
        </div>
    ); 
}

export default MasInfo;